<template>
  <div class="navbar">
    <InnerNavbar
      :content="content"
      :mobile="mobile"
      :tablet="tablet"
      :desktop="desktop"
      :menuOpen="menuOpen"
      @setMenuOpen="setMenuOpen"
    />
    <LanguageSwitcher
      :content="content.languageSwitcher"
      class="navbar__languages"
      v-if="desktop"
    />
    <SocialShare v-if="desktop" />
    <Transition name="slide-in">
      <ModalMenu
        :content="content.modalMenu"
        :languageContent="content.languageSwitcher"
        v-if="menuOpen"
        @setMenuOpen="setMenuOpen"
      />
    </Transition>
  </div>
</template>
<script setup>
import { computed } from "@vue/reactivity";
import { inject, ref } from "vue";
import { useI18n } from "vue-i18n";
import { deepMap } from "../utilities/functions/deepMap";
// import { pageIcons } from "../plugins/page-icons";
import LanguageSwitcher from "./shared/LanguageSwitcher.vue";
import InnerNavbar from "./shared/InnerNavbar.vue";
import ModalMenu from "./shared/ModalMenu.vue";
import SocialShare from "./shared/SocialShare.vue";

const menuOpen = ref(false);

const setMenuOpen = () => {
  menuOpen.value = !menuOpen.value;
};

const { tm, rt } = useI18n();
const content = computed(() => deepMap(tm("header"), rt));

const tvaMq = inject("$tvaMq");
const mobile = computed(() => tvaMq.value === "mobile");
const tablet = computed(() => tvaMq.value === "tablet");
const desktop = computed(() => tvaMq.value === "desktop");
</script>

<style lang="scss" scoped>
.navbar {
  position: fixed;
  width: 100vw;
  padding: toRem(14) toRem(30);
  padding-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 3;

  &__languages {
    margin-left: auto;
    margin-right: toRem(25);
  }

  &__social {
    &__icon {
      color: $scala-grigi-gray_2;
      transition: color 0.3s linear;
    }
    &:hover > .navbar__social__icon {
      color: $scala-grigi-gray_1;
    }
  }
}

.tablet {
  .navbar {
    padding: 0;
  }
}

.mobile {
  .navbar {
    padding: 0;
  }
}
</style>
